import { Reveal, Overline } from "./shared";

export const PageHero = ({ overline, title, intro }) => (
  <section className="bg-nuit pb-16 pt-36 lg:pb-20 lg:pt-44" data-testid="page-hero">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal>
        <Overline light>{overline}</Overline>
        <h1 className="font-display mt-4 max-w-4xl text-3xl font-medium leading-tight tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">{intro}</p>}
      </Reveal>
    </div>
  </section>
);
